import oikosApi from '../services/oikos'

export const getFileName = (file) => file?.path || file?.name || `arquivo-${Date.now()}`

/**
 * Mesmo fluxo do Contas a receber / Faturamento: insert documento ? documentoVinc ? upload_file em arquivo.
 * @returns {Promise<number>} documento_id
 */
export async function uploadFileToDocumento({
  tpDocumentoId,
  tabRef,
  tabId,
  file,
  documentoDesc,
  extraVincs = [],
  documentoDtEmissao,
  documentoIniVig,
  documentoFimVig,
}) {
  const fileName = getFileName(file)
  const data = {
    tpDocumento_id: tpDocumentoId,
    documento_desc: documentoDesc || fileName,
    privacidade_id: 2,
  }
  if (documentoDtEmissao) data.documento_dtEmissao = documentoDtEmissao
  if (documentoIniVig) data.documento_iniVig = documentoIniVig
  if (documentoFimVig) data.documento_fimVig = documentoFimVig

  const documentCreated = await oikosApi.post('/', {
    action: 'insert',
    table: 'documento',
    data,
  })
  const documentoId = documentCreated?.data?.[0]?.documento_id
  if (!documentoId) throw new Error('Falha ao criar documento.')

  const vincs = [{ tabRef, tabId }, ...(Array.isArray(extraVincs) ? extraVincs : [])]
  const seen = new Set()
  for (const v of vincs) {
    const ref = String(v?.tabRef || '').trim()
    const id = Number(v?.tabId)
    if (!ref || !(id > 0)) continue
    const key = `${ref}:${id}`
    if (seen.has(key)) continue
    seen.add(key)
    await oikosApi.post('/', {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentoId,
        documentoVinc_tabRef: ref,
        documentoVinc_tabId: id,
        documentoVinc_ativo: 1,
      },
    })
  }

  const formData = new FormData()
  formData.append('file', file, fileName)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentoId)
  formData.append('arquivo_privacidade', 2)
  formData.append('arquivo_desc', fileName)
  await oikosApi.post('/', formData)

  return documentoId
}

